import React from "react"
import * as styles from "./style.module.scss"

export interface CaseItem {
  href: string
  text: string
  Logo?: React.ReactNode // сюда SVG-компонент
}

export function CasesList({ items }: { items: CaseItem[] }) {
  if (!items?.length) return null

  return (
    <>
      {items.map((item, i) => (
        <a key={i} href={item.href} target="_blank" rel="noreferrer" className={styles.caseItem}>
          {/* логотип опционально */}
          {item.Logo}
          <p>{item.text}</p>
          Узнать больше
        </a>
      ))}
    </>
  )
}
